import { render, staticRenderFns } from "./RecruiterAssessmentListing.vue?vue&type=template&id=539e0c49&scoped=true"
import script from "./RecruiterAssessmentListing.vue?vue&type=script&lang=ts"
export * from "./RecruiterAssessmentListing.vue?vue&type=script&lang=ts"
import style0 from "./RecruiterAssessmentListing.vue?vue&type=style&index=0&id=539e0c49&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539e0c49",
  null
  
)

export default component.exports